import { Component, Inject, OnInit } from '@angular/core';
import { PublisherService } from '../../../core/services/publisher.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ProductsService } from '../products.service';
import { ProductUtilService } from '../product-util.service';
import {
  Product,
  ValidateProductRequest
} from '../../../shared/models/product';
import { ValidateProduct } from '../../../shared/models/order';
import { FavouritesConfirmationComponent } from '../favorites/favourites-confirmation/favourites-confirmation.component';
import {
  AddProductToFavRequest,
  ItemNum
} from '../../../shared/models/product';
import { CreateRenameFavoritesComponent } from '../favorites/create-rename-favorites/create-rename-favorites.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UserProperty, CacheConstant } from '../../../core/constants/app.constant';
import { UserService } from '../../../core/services/user.service';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { DatePipe } from '@angular/common';
@Component({
  selector: 'par-purchase-history',
  templateUrl: './purchase-history.component.html',
  styleUrls: ['./purchase-history.component.scss']
})
export class PurchaseHistoryComponent implements OnInit {
  /***************Properties***************/
  private purchaseHistoryData: Array<any> = [];
  websiteName = this.cache.get(CacheConstant.Env_Properties).theme;
  qtyLength = this.cache.get(CacheConstant.Env_Properties).qtyFieldLength;
  secondLastLogin=this.cache.get(CacheConstant.User_Auth_Detail).secondLastLogin;
  lastLogin:string;
  isCaseMisMatch: boolean = false;
    invoiceList: any[];
  invoiceFilter: any[] = [];
  productHistoryColumns = [
    'itemId',
    'ndc',
    'brandName',
    'productDescription',
    'manufacturer',
    'size',
    'form',
    'lastPurchaseDate',
    'lastPurchasePrice',
    'currentPrice',
    'caseQuantity',
    'quantity',
    'inCart',
    'addToFav',
    'watchlist'
  ];
  productHistoryFilterOptions = {
    sortBy: 'description',
    direction: 'asc'
  };
  emptyGrid = {
    showMessage: false,
    message: 'No history found'
  };
  disableAddToCart: Boolean = true;
  purchaseHistoryDataSource: MatTableDataSource<any> = new MatTableDataSource();

  addProductToFavRequest: AddProductToFavRequest;
  userDetailNum: null;
  favLists: any;
  item: ItemNum;
  watchlistMsg: string;
  caseAlertObject: any;
  caseQtyMismatch = []; 
  hasCaseQtyError: boolean = false;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(
    private cache: AppCacheService,
    public dialogRef: MatDialogRef<PurchaseHistoryComponent>,
    private productService: ProductsService,
    private productUtil: ProductUtilService,
    private router: Router,
    private userService: UserService,private datePipe:DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: string  ) { }

  ngOnInit() {
    this.lastLogin=this.datePipe.transform(this.secondLastLogin, 'MM/dd/yyyy');
    this.secondLastLogin =this.datePipe.transform(this.secondLastLogin, 'yyyyMMdd');
    this.caseAlertObject = this.userService.getCaseData();
    if(this.data.length==0)
    PublisherService.changeBannerHeader('Product History');   
    this.getProductHistory();
    this.getFavouritesList();
  }
  /***************Constructor***************/

  /***************Component Methods***************/

     
  coldAlert(product) {
    return this.productService.isProductRefrigerated(product);
  }

  hazardAlert(product) {
    return this.productService.isProductHazardous(product);
  }

  isAddToCartDisable() {
    return this.getQuantityProducts().length > 0;
  }

  onProductHistorySorts() {
    const sortBy = this.productHistoryFilterOptions.sortBy;
    if (this.purchaseHistoryData.length > 1) {
      this.purchaseHistoryData.sort(function (a, b) {
        if (a[sortBy] < b[sortBy]) {
          return -1;
        }
        if (a[sortBy] > b[sortBy]) {
          return 1;
        }
        return 0;
      });
      if (this.productHistoryFilterOptions.direction === 'des') {
        this.purchaseHistoryData.reverse();
      }
      this.purchaseHistoryDataSource = new MatTableDataSource(
        this.purchaseHistoryData
      );
    }
  }


  checkProductBeforeAddToCart() {

    if(this.isCaseMisMatch === true){
      return;
    } 
    this.onAddToCartSubmit();
    } 

  onAddToCartSubmit() {
    const quantityProducts = this.getQuantityProducts();

    if (quantityProducts.length > 0) {
      const validateProductRequest: ValidateProductRequest = {
        items: [],
        shipToNum: null,
        soldToNum: null
      };

      quantityProducts.forEach(order => {
        validateProductRequest.items.push({ itemId: order.itemId, orderQuantity: order.quantity, packQuantity: order.packQuantity });
      });

      this.productService
        .validate(validateProductRequest)
        .subscribe((response: any) => {
          if (!response.hasError) {
            this.onValidateProductResponse(response);
          }
        });
    }
  }

  onSelectList(product: any) {
    this.productUtil.onSelectFavList(product.favListSelected, product.itemId, product.description,
      this.userDetailNum, this.favLists).subscribe((result: any) => {
        product.favListSelected = '';
        if (result.refreshList) {
          this.getFavouritesList();
        }
      });
  }

  onWatchlistToggle (product: any) {
    if (product.isWatchListItem) {
      this.productUtil.onAddToWatchListToaster(product, product.itemId, product.description);
    } else {
      this.productUtil.onDeleteFromWatchListToaster(product, product.itemId, product.description);
    }
  }
 //Change event to filter the purchase history
  onInvFilterSelect(element) {
    let invoiceList = this.invoiceList;
    let filterlst;
    if (element.value != "allInv") {
      filterlst = this.invoiceFilter.filter(e => e.defaultSold == element.value);
      if (filterlst.length != 0)
        invoiceList = invoiceList.filter(e => e.soldToNum == filterlst[0].soldToNum);
      else
        invoiceList = [];
    }
    this.purchaseHistoryDataSource = new MatTableDataSource<any>(invoiceList);
  }
  /***************Component Methods***************/

  /***************Private Methods***************/

  private getProductHistory() {
    this.productService.getHistoryDetails().subscribe((response: any) => {
      if (!response.hasError && response.length > 0) {
        this.purchaseHistoryData = response.filter(
          product => product.currentPrice > 0
        );
          this.purchaseHistoryData.forEach(product => {
          product.invoicePrice = product.invoicePrice;
          product.invoiceDate = this.formatInvoiceDate(product.invoiceDate);
          product.quantity = null;
          product.excluded = this.productService.isExcluded(product);
          product.favListSelected = '';
          product.isQtyMismatch = false;
        });
        this.invoiceList=this.purchaseHistoryData;
        const defaultAccount = this.userService.getDefaultAccount();
        let defaultAccountName = this.userService.getDefaultAccountMasterData();
        let isJointAcc = this.purchaseHistoryData.filter((v, i) => this.purchaseHistoryData.findIndex(item => item.isJointAccount == v.isJointAccount) === i);
        this.invoiceFilter = this.purchaseHistoryData.filter((v, i) => this.purchaseHistoryData.findIndex(item => item.soldToNum == v.soldToNum) === i);
        this.invoiceFilter.forEach(e => {
          if (defaultAccountName.division == "Major") {
            if (defaultAccount.accountSoldToNum == e.soldToNum) e.defaultSold = "Major";
            else e.defaultSold = "Rugby";
          }
          else if (defaultAccountName.division == "Rugby") {
            if (defaultAccount.accountSoldToNum == e.soldToNum) e.defaultSold = "Rugby";
            else e.defaultSold = "Major";
          }
        });
        if (defaultAccountName.division == "Rugby")
          this.invoiceFilter.reverse();
        this.invoiceFilter.unshift(isJointAcc[0].isJointAccount);
       
        this.onProductHistorySorts();
        if(this.data=='price changes alert'){
        this.purchaseHistoryData=this.purchaseHistoryData.filter(item=>item.effectiveDate>=this.secondLastLogin)
        }
        this.purchaseHistoryDataSource = new MatTableDataSource(
          this.purchaseHistoryData
        );
        this.emptyGrid.showMessage =
          this.purchaseHistoryData.length <= 0 ? true : false;
      } else {
        this.emptyGrid.showMessage = true;
      }
    });
  }

  checkCaseQtyMultiplier(product) {
    if(!isNaN(product.quantity) && product.quantity % product.packQuantity !== 0 && 
    this.caseAlertObject.showCaseAlert ) {
      product.isQtyMismatch = true;
      this.isCaseMisMatch = true;
    }
    else {
      product.isQtyMismatch = false;
      this.caseQtyMismatch = this.purchaseHistoryData.filter((product) => {
        return product.isQtyMismatch === true;
      });
      this.caseQtyMismatch.length === 0 ? this.isCaseMisMatch = false : this.isCaseMisMatch = true;

    }    
  }

  private onValidateProductResponse(response: any) {
    if (!response.hasEror && response.items && !response.items.isEmpty()) {
      const validatedProducts = response.items as Array<ValidateProduct>;

      const invalidProduct = this.validateAddtoCartProducts(validatedProducts);
      if (invalidProduct.invalidProducts.length > 0) {
        invalidProduct.dialog.afterClosed().subscribe(result => {
          this.addProductsToCart(invalidProduct.invalidProducts);
        });
      } else {
        this.addProductsToCart(invalidProduct.invalidProducts);
      }
    }
  }

  private addProductsToCart(invalidProducts: Array<any>) {
    const products: Product[] = [];
    const quantityProducts = this.getQuantityProducts();

    quantityProducts.forEach(product => {
      if (
        invalidProducts.length <= 0 ||
        invalidProducts.find(ip => ip.itemId === product.itemId) === undefined
      ) {
        products.push({
          itemId: product.itemId,
          cartQuantity: product.quantity.toNumber(),
          sku: product.sku ? product.sku.toString() : null,
          price: product.currentPrice,
          allocatedQuantity: product.allocatedQuantity,
          packQuantity: product.packQuantity ? product.packQuantity : null
        } as Product);
      }
    });

    if (products.length > 0) {
      this.productUtil.addToCart(products, null, "Order History").subscribe((result: any) => {
        if (result && result.orderDetails) {
          this.updateOnOrderValue(result.orderDetails);
        }
      });
    } else {
      this.updateOnOrderValue([]);
    }
  }

  private validateAddtoCartProducts(validatedProducts) {
    const products: Product[] = [];
    const quantityProducts = this.getQuantityProducts();

    validatedProducts.forEach(product => {
      quantityProducts
        .filter(p => this.productUtil.isProductMatch(p.itemId, product))
        .forEach(order => {
          products.push({
            itemId: product.itemId,
            cartQuantity: order.quantity.toNumber(),
            sku: product.sku ? product.sku.toString() : '',
            price: product.price,
            allocatedQuantity: product.allocatedQuantity
          } as Product);
        });
    });

    return this.productUtil.getInvalidCartProducts(products);
  }

  private formatInvoiceDate(dateString) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return month + '/' + day + '/' + year;
  }

  private getQuantityProducts() {
    return this.purchaseHistoryDataSource.data.filter(
      product => product.quantity && product.quantity.toNumber() > 0
    );
  }

  private updateOnOrderValue(details) {
    this.purchaseHistoryData.forEach(productHist => {
      productHist.quantity = null;
      const productDetail =
        details && details.find(p => p.itemId === productHist.itemId);

      productHist.onOrder =
        productDetail && productDetail.onOrder
          ? productDetail.onOrder
          : productHist.onOrder;
    });

    this.purchaseHistoryDataSource = new MatTableDataSource(
      this.purchaseHistoryData
    );
  }

  private getFavouritesList() {
    this.userDetailNum = this.userService.getProperty(
      UserProperty.UserDetailNumber
    );
    this.productService
      .getFavotiesList(this.userDetailNum)
      .subscribe((response: any) => {
        if (!response.hasError) {
          if (response.length) {
            response.sort((a, b) => {
              const x = a.name.toLowerCase();
              const y = b.name.toLowerCase();
              if (x < y) {
                return -1;
              }
              if (x > y) {
                return 1;
              }
              return 0;
            });
            this.favLists = response;
          }
        }
      });
  }
  displayedColumnsFun(): string[]{
  
    if(this.websiteName=='Parmed'){
      return this.productHistoryColumns;
    }
if(this.data=='price changes alert'){
  let Items=['inCart','addToFav','watchlist']
  this.productHistoryColumns.forEach((item:any,index:number) => {
    if(Items.indexOf(item)>-1)
    {
      this.productHistoryColumns.splice(index,1)
    }
  });
  return this.productHistoryColumns;
  }

    if(this.websiteName=='Major'){
      return this.productHistoryColumns.filter(c=> c!='manufacturer');
    }

  }
  onClose() {
    this.dialogRef.close();
  }
  /***************Private Methods***************/
}
